import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import { ListAddIcon } from '@img/icons';
import { navigator } from '@types';

const transportNav = () => {
	const root = `/transport`;
	return [
		{
			label: 'All Loads',
			icon: (color:string) => <LocalShippingOutlinedIcon style={{ color: color }} />,
			link: `${root}/all-loads`,
			enabled: true,
			activeURL: 'all-loads'
		},
		{
			label: 'POD to be assigned',
			icon: (color:string) => <DescriptionOutlinedIcon style={{ color: color }} />,
			link: `${root}/pod-to-be-assigned`,
			enabled: true,
			activeURL: 'pod-to-be-assigned',
		},
		{
			label: 'Shipment Docs',
			icon: (color:string) => <UploadFileOutlinedIcon style={{ color: color }} />,
			link: `${root}/shipment-docs`,
			enabled: true,
			activeURL: 'shipment-docs',
		},
		{
			label: 'Superdock',
			icon: (color:string) => <ListAddIcon color={color} />,
			link: `${root}/superdock`,
			enabled: true,
			activeURL: 'superdock'
		},
		{
			label: 'Carrier Recommendation',
			icon: (color:string) => <WorkspacePremiumOutlinedIcon style={{ color: color }} />,
			link: `${root}/carrier_recommendation`,
			enabled: true,
			activeURL: 'carrier_recommendation'
		},
	] as navigator[];
}

export default transportNav;
